import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Opportunities, OpportunityHistory } from './opportunities';
import { OpportunitiesDTO } from './opportunities-dto';
import { Observable } from 'rxjs';
// import { Http, ResponseContentType, RequestOptions } from '@angular/http';
import { Binary } from '@angular/compiler';
import { Filters } from '../boardsPage/filters-data';



@Injectable({
  providedIn: 'root'
})
export class OpportunitiesService {

  constructor(private httpClient: HttpClient) { }

  filters: Filters = new Filters();
  currentYear = new Date().getFullYear() + '';

  public setFilters(month: any, region: string, sales: string, sector: string, status: string, year: string[], quarter: any[], productKind: string[], gstatus: string, renewable: boolean, sbmchannel: string
    , customersFilter: string, opportunitiesNameFilter: string, partnerFilter: boolean, ownersNameFilter: string) {

    this.filters.sales = sales;
    this.filters.region = region;
    this.filters.sector = sector;
    this.filters.status = status;
    this.filters.quarter = quarter;
    this.filters.year = year;
    this.filters.renewable = renewable;
    this.filters.sbmchannel = sbmchannel;
    this.filters.productKind = productKind;
    this.filters.gstatus = gstatus;
    this.filters.month = month;
    this.filters.customersFilter = customersFilter;
    this.filters.opportunitiesNameFilter = opportunitiesNameFilter;
    this.filters.partner = partnerFilter;
    this.filters.ownersNameFilter = ownersNameFilter;

    // console.log("setFilters service called......");
    // console.log("region:" + this.filters.region);
    // console.log("this.filters.sales:" + this.filters.sales);
    // console.log("this.filters.sector:" + this.filters.sector);
    // console.log("this.filters.status:" + this.filters.status);
    // console.log("this.filters.year:" + this.filters.year);
    // console.log("this.filters.quarter:" + this.filters.quarter);
    // console.log("this.filters.productKind:" + this.filters.productKind);
    // console.log("gstatus:" + this.filters.gstatus);
    // console.log("this.filters.renewable:" + this.filters.renewable);
    // console.log("this.filters.sbmchannel:" + this.filters.sbmchannel);
    // console.log(" this.filters.month:" + this.filters.month);
    // console.log(" this.filters.customersFilter:" + this.filters.customersFilter);
    // console.log(" this.filters.opportunitiesNameFilter:" + this.filters.opportunitiesNameFilter);
  }

  getFilters(): Filters {

    return this.filters;
  }

  resetFilters() {
    // console.log("reset boards service called......");
    this.filters.sales = 'All'
    this.filters.region = 'All'
    this.filters.sector = 'All'
    this.filters.status = 'All'  // from Null
    this.filters.quarter = [];
    this.filters.month = [];
    this.filters.year = [this.currentYear]
    this.filters.renewable = false;
    this.filters.productKind = ['SWG', 'STG']
    this.filters.gstatus = 'All'
    this.filters.sbmchannel = 'All'
    this.filters.customersFilter = 'All';
    this.filters.opportunitiesNameFilter = 'All';
    this.filters.partner = false;
  }

  retriveLeadsDataList() {
    let userEmail = sessionStorage.getItem('loginUserName');
    return this.httpClient.get<Opportunities[]>('api/v1/opportunity/leadsdata/' + userEmail);
  }

  retrieveOpportunity(opportunityId: number) {
    return this.httpClient.get<OpportunitiesDTO[]>('api/v1/opportunity/' + opportunityId).pipe(catchError(this.errorHandler));
  }

  deleteOpportunity(opportunityId: number) {
    return this.httpClient.delete('api/v1/opportunity/remove/' + opportunityId);
  }

  hasDeleteOpportunityPermission() {
    return this.httpClient.get<boolean>('api/v1/user/haseRole/canDelete');
  }

  hasEditOpportunityPermission() {
    return this.httpClient.get<boolean>('api/v1/user/haseRole/canEdit');
  }

  hasSWGOpportunityPermission() {
    return this.httpClient.get<boolean>('api/v1/user/haseRole/SWG');
  }

  hasSTGOpportunityPermission() {
    return this.httpClient.get<boolean>('api/v1/user/haseRole/STG');
  }

  addOpportunity(opportunitiesDTO: OpportunitiesDTO): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    let userEmail = sessionStorage.getItem('loginUserName');
    return this.httpClient.post<any>('/api/v1/opportunity/' + userEmail, opportunitiesDTO, { headers }).pipe(catchError(this.errorHandler));
  }

  updateOpportunity(opportunitiesDTO: OpportunitiesDTO): Observable<any> {
    const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
    let userEmail = sessionStorage.getItem('loginUserName');

    // console.log("updateOpportunity service called......");
    // console.log("opportunitiesDTO:" + opportunitiesDTO);
    return this.httpClient.put<any>('/api/v1/opportunity/', opportunitiesDTO, { headers }).pipe(catchError(this.errorHandler));
  }

  errorHandler(error: HttpErrorResponse) {
    console.log(error.message);
    return throwError(error.message || 'Server Error');

  }


  // downloadReport(sector: string, status: string, year: any, quarter: any, month: any, opportunity: string, customer: string, gstatus: string, sbmchannel: string, renewable: boolean, format: string, partner: boolean) {

  //   /*console.log("downloadReport service called......");
  //   console.log("sector:" + sector);
  //   console.log("status:" + status);
  //   console.log("year:" + year);
  //   console.log("quarter:" + quarter);
  //   console.log("gstatus:" + gstatus);
  //   console.log("renewable:" + renewable);
  //   console.log("sbmchannel:" + sbmchannel);
  //   console.log(" month:" +  month);
  //   console.log("00000000000000000000000000000000000000000")*/

  //   let loginUserName = sessionStorage.getItem('loginUserName');
  //   const options = new RequestOptions({
  //     responseType: ResponseContentType.ArrayBuffer

  //   });
  //   return this.http.get("/api/v1/opportunity/leadsdata/report/" + sector + "/" + status + "/" + year + "/" + quarter + "/" + month + "/" + opportunity + "/" + customer + "/" + gstatus + "/" + loginUserName + "/" + format + "/" + sbmchannel + "/" + renewable + "/" + partner, options);
  //   // return this.httpClient.get<Blob>("/api/v1/opportunity/leadsdata/report/" + sector + "/" + status + "/" + year + "/" + quarter + "/" + month + "/" + opportunity + "/" + customer + "/" + gstatus + "/" + loginUserName + "/" + format);

  // }
  downloadReportByIds(format: string, ids: any[]) {
    let loginUserName = sessionStorage.getItem('loginUserName');
    
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType: 'blob' as 'json'  // Set response type to 'blob' to handle binary data
    };
    
    return this.httpClient.post(`/api/v1/opportunity/getReportByIds/${format}`, ids, options);
  }

  // downloadReportByIds(format: string, ids: number[]): Observable<Blob> {
  //   console.log("downloadReportByIds service called......");
  //   console.log("format:" + format);
  //   console.log("ids:" + ids);
  //   const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('basicauth') });
  //   return this.httpClient.post<Blob>(`/api/v1/opportunity/getReportByIds/${format}`, ids, { headers, responseType: 'blob' as 'json' })
  //     .pipe(catchError(this.errorHandler));
  // }
  

  retrieveOpportunityHistory(opportunityId: number) {

    return this.httpClient.get<OpportunityHistory[]>('/api/v1/opportunity/historyLog/for/' + opportunityId).pipe(catchError(this.errorHandler));
  }


}